<!--<mat-selection-list class="list" #selectionListBookings
                    [(ngModel)]="selectedOptions"
                    (selectionChange)="getBookingSelection()">-->
<header class="header booking-list-header">
    <mat-checkbox *ngIf="bookings.length > 0 && selectable"
                  [checked]="selectedOptions.length === bookings.length"
                  class="btn actionHeaderLink e2e-select-all-booking"
                  (change)="storeSelection($event)">
        <span class="space-left">{{ getSelectionRange() }}</span>
    </mat-checkbox>

    <mat-slide-toggle class="btn actionDo sep-left"
                      *ngIf="selectable && canFilter && selectedOptions.length > 0"
                      [(ngModel)]="filterThisSelection">
        {{ labels.selectionFilter }}
    </mat-slide-toggle>

    <ng-container *permissionIf="'sasha.bookingExport.use'">
        <btn *ngIf="selectable && canExportExcel && selectedOptions.length > 0"
             class="btn-csv"
             [label]="labels.exportExcel" type="actionDo" (click)="action('csvExport')"></btn>
    </ng-container>

    <ng-content select=".list-header"></ng-content>
</header>


<ng-content select=".list-body"></ng-content>
<configurable-table *ngIf="bookingSearchConfig"
                    [config]="bookingSearchConfig"
                    [bookings]="bookings"
                    [selectedOptions]="selectedOptions"
                    (onSelect)="onSelect.emit($event)"></configurable-table>
<!-- <mat-list-option #listOptionBooking
                  (mouseenter)="listOptionBooking.focus()"
                  class="list-row"
                  [ngClass]="{'isSelected': listOptionBooking.selected}"
                  [value]="booking"
                  [disabled]="!selectable"
                  [hidden]="filterThisSelection ? !listOptionBooking.selected : false"
                  [checkboxPosition]="checkboxPosition"
                  *ngFor="let booking of bookings; trackBy: getBookingId">
     <booking [booking]="booking"></booking>

 </mat-list-option>
</mat-selection-list>-->
